'use client';

import cn from 'classnames';
import { AnimatePresence, motion } from 'framer-motion';
import { HTMLAttributes, useRef, useState } from 'react';

const modalVariants = {
  initial: {
    opacity: 0,
  },
  animate: {
    opacity: 1,
    transition: {
      ease: 'linear',
      duration: 1,
    },
  },
  exit: {
    opacity: 0,
    transition: {
      ease: 'linear',
      duration: 1,
    },
  },
};

export function Share(props: HTMLAttributes<HTMLButtonElement>) {
  const { className, ...rest } = props;
  const [showModal, setShowModal] = useState(false);
  const to = useRef(null);
  const share = () => {
    navigator.clipboard.writeText(window.location.href);
    setShowModal(true);
    clearTimeout(to.current);
    to.current = setTimeout(() => {
      setShowModal(false);
    }, 2000);
  };
  return (
    <button
      className={cn('block relative', className)}
      title="Copy URL to clipboard."
      onClick={share}
      {...rest}
    >
      <svg
        className={cn('social-icons')}
        width={24}
        height={24}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.667 5c-.71 0-1.334.6-1.334 1.4a1.446 1.446 0 0 0 .177.693 1.327 1.327 0 0 0 1.157.707c.71 0 1.333-.6 1.333-1.4 0-.8-.623-1.4-1.333-1.4ZM14.42 8.913a3.275 3.275 0 0 0 2.246.887C18.534 9.8 20 8.251 20 6.4S18.534 3 16.667 3c-1.868 0-3.334 1.549-3.334 3.4 0 .268.031.529.089.78L9.579 9.487A3.275 3.275 0 0 0 7.333 8.6C5.466 8.6 4 10.149 4 12s1.466 3.4 3.333 3.4c.873 0 1.658-.338 2.246-.887l3.844 2.303a3.46 3.46 0 0 0-.09.784c0 1.851 1.466 3.4 3.334 3.4C18.534 21 20 19.451 20 17.6s-1.466-3.4-3.333-3.4c-.871 0-1.655.337-2.243.885l-3.846-2.306a3.46 3.46 0 0 0 0-1.56l3.843-2.306Zm-5.969 2.324a1.012 1.012 0 0 0 .055.097c.101.195.16.421.16.666a1.444 1.444 0 0 1-.177.694 1.327 1.327 0 0 1-1.157.706C6.623 13.4 6 12.8 6 12c0-.8.623-1.4 1.333-1.4.456 0 .877.248 1.12.637Zm7.02 5.739a1.01 1.01 0 0 0 .104-.182 1.324 1.324 0 0 1 1.09-.594c.71 0 1.334.6 1.334 1.4 0 .8-.623 1.4-1.333 1.4s-1.334-.6-1.334-1.4c0-.227.05-.438.139-.624Z"
          fill="#0D0D0D"
        />
      </svg>
      <AnimatePresence>
        {showModal && (
          <motion.div
            key="modal"
            variants={modalVariants}
            initial="initial"
            animate="animate"
            exit="exit"
            className="absolute pointer-events-none left-full bottom-full bg-white rounded-[4px] drop-shadow-md p-2 w-[200px]"
          >
            URL has been copied to your clipboard.
          </motion.div>
        )}
      </AnimatePresence>
    </button>
  );
}
